<template>
  <base-modal name="extendMeeting" width="380">
    <template #body>
      <div class="px-5 pt-40 pb-20">
        <p class="text-title font-semibold text-24 px-5">{{ $t('extend_meeting') }}</p>
        <div class="flex mt-40" dir="ltr">
          <div class="duration-item" @click="decrease">-</div>
          <div class="duration-text">{{ timeDuration }}</div>
          <div class="duration-item" @click="increase">+</div>
        </div>
        <div class="end-time-container">
          <div>
            {{ $t('end_time') }}
          </div>
          &nbsp;
          <div class="end-time" dir="ltr">
             {{ endTime }}
          </div>
        </div>
        <div class="flex gap-x-10">
          <base-button
            height="48"
            width="180"
            @click.native="closeModals('extendMeeting')"
            buttonType="cancel"
            radius="default"
          >
            <template #text>
              <span class="text-14 font-bold">
                {{ $t('cancel') }}
              </span>
            </template>
          </base-button>
          <base-button
            height="48"
            width="180"
            buttonType="primary"
            radius="default"
            @click.native="extendHandler()"
          >
            <template #text>
              <span class="text-14 font-bold"> {{ $t('done') }} </span>
            </template>
          </base-button>
        </div>
      </div>
    </template>
  </base-modal>
</template>
<script>
import axiosConfig from '@/services/axios.config';
import serverErrorsHandler from '@/utils/serverErrorsHandler';
import BaseModal from '@/components/modals/BaseModal.vue';
import BaseButton from '@/components/base/BaseButton.vue';

const moment = require('moment-jalaali');

export default {
  name: 'extendMeeting',
  components: {
    BaseModal,
    BaseButton,
  },
  props: {
    meetingInfo: {
      type: Object,
    },
  },
  data() {
    return {
      minuteCount: 5,
      hourCount: 0,
      duration: 5,
      companyId: this.$route.params.companyId,
      deviceId: this.$route.params.deviceId || this.meetingInfo.device_id,
      reserveId: this.$route.params.reserveId,
    };
  },
  computed: {
    timeDuration() {
      return `${this.zeroPadded(this.hourCount)} : ${this.zeroPadded(this.minuteCount)}`;
    },
    endTime() {
      const endMinute = moment(this.meetingInfo.ended_at).add(this.duration, 'minutes').minute();
      const endHour = moment(this.meetingInfo.ended_at).add(this.duration, 'minutes').hour();
      return `${this.zeroPadded(endHour)}:${this.zeroPadded(endMinute)}`;
    },
  },
  methods: {
    extendHandler() {
      axiosConfig
        .post(
          `/companies/${this.companyId || this.meetingInfo.company_id}/reservations/${this.reserveId || this.meetingInfo.id}/extend-meeting`,
          { extended_time: this.duration, device_id: this.deviceId },
        )
        .then(() => {
          this.closeModals('extendMeeting');
          this.$emit('updateMeetingInfo');
          this.$toast.success(this.$t('extended'));
          this.duration = 5;
          this.hourCount = 0;
          this.minuteCount = 5;
        })
        .catch((error) => {
          serverErrorsHandler(error);
        });
    },
    zeroPadded(num) {
      return num < 10 ? `0${num}` : num;
    },
    closeModals(...modals) {
      modals.map((modalName) => this.$store.dispatch('modal/close', modalName));
    },
    increase() {
      if (this.duration >= 5) {
        this.duration += 5;
        if (this.minuteCount + 5 === 60) {
          this.hourCount += 1;
          this.minuteCount = 0;
        } else {
          this.minuteCount += 5;
        }
      }
    },
    decrease() {
      if (this.duration > 5) {
        this.duration -= 5;
        if (this.hourCount > 0) {
          if (this.minuteCount - 5 < 0) {
            this.hourCount -= 1;
            this.minuteCount = 55;
          } else {
            this.minuteCount -= 5;
          }
        } else if (this.minuteCount - 5 > 0) {
          this.minuteCount -= 5;
        }
      }
    },
  },
};
</script>
<style scoped>
.duration-item {
  @apply w-70 h-70 shadow-lg rounded-full flex justify-center items-center text-48
    text-title cursor-pointer  select-none lg:w-56 lg:h-56 bg-secondary;
}
.duration-text {
  @apply text-36 flex-grow self-center text-center my-20 mx-10 select-none;
}
.end-time-container {
  @apply my-30 text-18 text-center flex justify-center items-center lg:my-10;
}
.end-time {
  direction: ltr;
}
</style>
